const el = '.kb-component--global-profile-login-overlay'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((GlobalProfileLoginOverlayDOM)=>{
            
            const loginUrl = GlobalProfileLoginOverlayDOM.dataset.loginUrl
            
            Store.commit('main/set_page_overlay_content_data', {
                headerLoginUrl: loginUrl
            })

        })
    }
}